import React from "react";

const Consultation = ({ contactRef }) => {
  const handleScrollToContact = () => {
    contactRef?.current?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      className="consultation-container"
      aria-labelledby="consultation-heading"
    >
      <div className="inner">
        <h1 className="title">Ready to Harness the Power of Technology?</h1>
        <p className="desc">
          Reach out to Porto Consulting today to explore how our specialized
          Energy expertise can support your business growth. Take the first step
          towards unlocking your full potential with our expert guidance and
          innovative solutions.
        </p>
        <button className="btn" onClick={handleScrollToContact}>
          Request Consultation
        </button>
      </div>
    </section>
  );
};

export default Consultation;
